export default __webpack_public_path__ + "static/media/iconEmailBlue.1e176bb6.svg";